// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {AlertBarMessageList} from './alert-bar-message-list';
import AlertMessage from '../../state/alert-message';
import {FormattedMessage} from 'react-intl';
import WarningAlertBar from '../alert-bar/warning-alert-bar';

const getDismissHandler = onDismiss =>
    () => {

        onDismiss('warning');

    };

export const WarningMessageContainer = props => {

    const title = props.warningMessages.length > 1 ?
        <FormattedMessage id='WARNING_MESSAGES_TITLE'/> :
        <FormattedMessage id='WARNING_MESSAGE_TITLE'/>;

    const content = props.warningMessages.length > 1 ? (
        <AlertBarMessageList messages={props.warningMessages}/>
    ) :
    props.warningMessages.length > 0 && props.warningMessages[0].message;

    return (
        <div className='warning-message-container'>
            <WarningAlertBar
                alertTitle={title}
                dismissHandler={getDismissHandler(props.onDismiss)}
            >
                {content}
            </WarningAlertBar>
        </div>
    );

};

WarningMessageContainer.displayName = 'InfoMessageContainer';

WarningMessageContainer.propTypes = {
    onDismiss: PropTypes.func.isRequired,
    warningMessages: PropTypes.arrayOf(
        PropTypes.instanceOf(AlertMessage)
    ).isRequired
};



// WEBPACK FOOTER //
// ./src/shared/components/alert-bar-container/warning-message-container.js